import { http } from './http';

import Player from '../models/player';
import Set from '../models/set';
import { playerName } from './view';

interface SetData {
  currentSet: number;
  sets: Set[];
  players: Player[];
}

function fillPlayerNames(sets: Set[], players: Player[]) {
  for (const s of sets) {
    s.playerNamesRed = s.playersRed.map((p) => playerName(p, players));
    s.playerNamesBlue = s.playersBlue.map((p) => playerName(p, players));
  }
}

async function getSets(): Promise<SetData> {
  const response = await http.get<SetData>('/set/get-data');
  const data = response.data;
  fillPlayerNames(data.sets, data.players);
  return data;
}

async function createSet(players: Player[], createTwo: boolean) {
  const playersRed = players.filter((p) => p.team === 'c');
  const playersBlue = players.filter((p) => p.team === 'm');
  if (playersRed.length !== 6 || playersBlue.length !== 6) {
    throw new Error('Missing players in the set');
  }

  const data = {
    playerRed1: playersRed[0].id,
    playerRed2: playersRed[1].id,
    playerRed3: playersRed[2].id,
    playerRed4: playersRed[3].id,
    playerRed5: playersRed[4].id,
    playerRed6: playersRed[5].id,
    playerBlue1: playersBlue[0].id,
    playerBlue2: playersBlue[1].id,
    playerBlue3: playersBlue[2].id,
    playerBlue4: playersBlue[3].id,
    playerBlue5: playersBlue[4].id,
    playerBlue6: playersBlue[5].id,
    createTwo: createTwo,
  };

  const response = await http.post('/set/', data);
  return response.data;
}

async function updateSet(id: number, data: object) {
  const response = await http.post(`/set/${id}/update`, data);
  return response.data;
}

async function updateSetScore(
  id: number,
  scoreRed: number,
  scoreBlue: number,
  set: Set,
  moveSet: boolean,
) {
  const data = {
    playerRed1: set.playersRed[0],
    playerRed2: set.playersRed[1],
    playerRed3: set.playersRed[2],
    playerRed4: set.playersRed[3],
    playerRed5: set.playersRed[4],
    playerRed6: set.playersRed[5],
    playerBlue1: set.playersBlue[0],
    playerBlue2: set.playersBlue[1],
    playerBlue3: set.playersBlue[2],
    playerBlue4: set.playersBlue[3],
    playerBlue5: set.playersBlue[4],
    playerBlue6: set.playersBlue[5],
    scoreRed: scoreRed,
    scoreBlue: scoreBlue,
    moveSet: moveSet,
  };

  return await updateSet(id, data);
}

export { getSets, fillPlayerNames, createSet, updateSet, updateSetScore };
